import { ButtonVariant } from "@repo/ui/Buttons/button";
import { iconButton } from "@repo/ui/Buttons/iconButton";
import { popoverStyle } from "@repo/ui/popover/style";
import { IconInfoCircle } from "@tabler/icons-react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import type { FC } from "react";
import {
  Button,
  Dialog,
  DialogTrigger,
  Heading,
  Popover,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { PH_MASK_CLASS } from "../analytics/sessionRecordingMasking.js";

export interface CustomerInfoPopoverProps {
  phoneNumber: string | null;
  contactEmail: string | null;
}

export const CustomerInfoPopover: FC<CustomerInfoPopoverProps> = (props) => {
  const { phoneNumber, contactEmail } = props;
  const parsedPhoneNumber = phoneNumber
    ? parsePhoneNumberFromString(phoneNumber)
    : undefined;
  const formattedPhoneNumber =
    parsedPhoneNumber?.country === "US"
      ? parsedPhoneNumber.formatNational()
      : phoneNumber;

  return (
    <DialogTrigger>
      <Button
        aria-label="Customer details"
        className={twMerge(
          iconButton({ variant: ButtonVariant.Tertiary }),
          "text-muted-foreground",
        )}
      >
        <IconInfoCircle className="size-5" />
      </Button>

      <Popover placement="bottom end" className={popoverStyle().popover()}>
        <Dialog className="outline-hidden">
          <div className="w-72 space-y-4 p-3">
            <Heading
              slot="title"
              className="text-base font-semibold text-foreground"
            >
              Customer details
            </Heading>
            {formattedPhoneNumber ? (
              <div>
                <div className="text-sm text-muted-foreground">Phone</div>
                <div
                  className={twMerge(
                    "mt-1 text-base break-all text-foreground",
                    PH_MASK_CLASS,
                  )}
                >
                  {formattedPhoneNumber}
                </div>
              </div>
            ) : null}
            {contactEmail ? (
              <div>
                <div className="text-sm text-muted-foreground">Email</div>
                <div
                  className={twMerge(
                    "mt-1 text-base break-all text-foreground",
                    PH_MASK_CLASS,
                  )}
                >
                  {contactEmail}
                </div>
              </div>
            ) : null}
          </div>
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
};
